const UPLOAD_ID_DIFFERENT_DATA_BIRTHDATE_ID = 'birthDate';

export { UPLOAD_ID_DIFFERENT_DATA_BIRTHDATE_ID };
